/* eslint-disable react/no-array-index-key */
import React, {
  lazy,
  Suspense,
  Fragment
} from 'react';
import {
  Routes as Switch,
  Navigate,
  Route
} from 'react-router-dom';

import GuestGuard from './components/GuestGuard';
import AuthGuard from './components/AuthGuard';
import DefaultLayout from './layouts/Defaul';


const routesConfig = [

  {
    exact: true,
    path: "/",
    component: () => <Navigate to="/login" />
  },
  {
    exact: true,
    path: '/404',
    component: lazy(() => import('./views/pages/Error404View'))
  },
  {
    exact: true,
    guard: GuestGuard,
    path: "/login",
    component: lazy(() => import("./views/auth/LoginView"))
  },

  {
    path: '/*',
    guard: AuthGuard,
    layout: DefaultLayout,
    routes: [
      /*
        {
          exact: true,
          path: '/app',
          component: () => <Redirect to="/app/reports/dashboard" />
        },
        {
          exact: true,
          guard: AuthGuard,
          path: '/home',
          component: lazy(() => import('./views/home/HomeView'))
        },
        */
      {
        exact: true,
        guard: AuthGuard,
        path: '/products',
        component: lazy(() => import('./views/products/ProductsView'))
      },
      {
        exact: true,
        guard: AuthGuard,
        path: '/categories',
        component: lazy(() => import('./views/categories/CategoriesView'))
      },
      {
        exact: true,
        guard: AuthGuard,
        path: '/images',
        component: lazy(() => import('./views/images/ImagesView'))
      },
      {
        component: () => <Navigate to="/404" />
      }
    ]
  },
  {
    path: '*',
    routes: [
      {
        component: () => <Navigate to="/404" />
      }
    ]
  }
];

const renderRoutes = (routes) => (routes ? (
  <Suspense fallback={<h1>Cargando...</h1>}>
    <Switch>
      {routes.map((route, i) => {
        const Guard = route.guard || Fragment;
        //const profiels = route.profiels || null;
        //const nprofiels = route.nprofiels || null;
        const Layout = route.layout || Fragment;
        const Component = route.component;
        return (
          <Route
            key={i}
            path={route.path}
            exact={route.exact}
            element={<Guard>
              <Layout>
                {route.routes
                  ? renderRoutes(route.routes)
                  : <Component />}
              </Layout>
            </Guard>
            }
          />
        );
      })}
    </Switch>
  </Suspense>
) : null);

function Routes() {
  return renderRoutes(routesConfig);
}

export default Routes;
